import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import CoreUiChatClientAvatar from "~/core-ui/vue/chat/CoreUiChatClientAvatar.vue";
import CoreUiAvatar from "~/core-ui/vue/chat/CoreUiAvatar.vue";
import CoreUiOperatorAvatar from "~/core-ui/vue/chat/CoreUiOperatorAvatar.vue";
import {computed} from "vue";
import Dictionary from "~/ts/library/Dictionary";
import isShowLikeClientMessage from "~/operatorApplication/ts/service/operators/isShowLikeClientMessage";
import CoreUiChatHistoryHelper from "~/core-ui/vue/chat/CoreUiChatHistoryHelper";


const __default__ = {
    name: "CoreUiChatHistoryMessageAvatar"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    client: {},
    message: {},
    operator: {},
    customOperatorStatusDictionary: {},
    avatarSize: {},
    you: {},
    showOperatorStatus: { type: Boolean, default: true }
  },
  setup(__props: any) {


let props = __props;

let customOperatorStatus = computed(() => {
    if (props.operator) {
        if (props.customOperatorStatusDictionary) {
            return props.customOperatorStatusDictionary[props.operator.customStatusId];
        }
    }
    return null;
});

let showLikeClientMessage = computed(() => {
    return isShowLikeClientMessage(props.message, props.client, props.you);
});



return (_ctx: any,_cache: any) => {
  return (_unref(showLikeClientMessage))
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (__props.client)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (__props.message.senderOverride?.avatar)
                ? (_openBlock(), _createBlock(CoreUiAvatar, {
                    key: 0,
                    src: __props.message.senderOverride?.avatar,
                    size: __props.avatarSize
                  }, null, 8, ["src", "size"]))
                : (_unref(CoreUiChatHistoryHelper).isOneOfCrossOperatorsChatMessage(__props.message) && __props.operator)
                  ? (_openBlock(), _createBlock(CoreUiOperatorAvatar, {
                      key: 1,
                      class: "avatar",
                      operator: __props.operator,
                      size: __props.avatarSize,
                      "status-color": _unref(customOperatorStatus) ? _unref(customOperatorStatus).color : null,
                      "show-status": __props.showOperatorStatus
                    }, null, 8, ["operator", "size", "status-color", "show-status"]))
                  : (_openBlock(), _createBlock(CoreUiChatClientAvatar, {
                      key: 2,
                      client: __props.client,
                      size: __props.avatarSize
                    }, null, 8, ["client", "size"]))
            ], 64))
          : _createCommentVNode("", true)
      ], 64))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (__props.message.senderOverride?.avatar)
          ? (_openBlock(), _createBlock(CoreUiAvatar, {
              key: 0,
              src: __props.message.senderOverride?.avatar,
              size: __props.avatarSize
            }, null, 8, ["src", "size"]))
          : (__props.operator)
            ? (_openBlock(), _createBlock(CoreUiOperatorAvatar, {
                key: 1,
                class: "avatar",
                operator: __props.operator,
                size: __props.avatarSize,
                "status-color": _unref(customOperatorStatus) ? _unref(customOperatorStatus).color : null,
                "show-status": !__props.message.virtualOperatorId && __props.showOperatorStatus
              }, null, 8, ["operator", "size", "status-color", "show-status"]))
            : (_openBlock(), _createBlock(CoreUiAvatar, {
                key: 2,
                class: "avatar",
                name: __props.message.operatorLogin,
                size: __props.avatarSize
              }, null, 8, ["name", "size"]))
      ], 64))
}
}

})